import { useRef } from "react";
import Cookies from "js-cookie";
import { API_ENDPOINTS } from "../../../api/endpoints";

export const useAddressValidator = () => {
  const jwtToken = Cookies.get("token");
  const cacheRef = useRef({});

  const normalizeAddress = (address) => {
    if (!address) return "";
    let normalized = address.replace(/ñ/g, "n").replace(/Ñ/g, "N");
    return normalized.normalize("NFD").replace(/[\u0300-\u036f]/g, "");
  };

  const searchAddresses = async (address) => {
    if (cacheRef.current[address]) {
      return cacheRef.current[address];
    }

    try {
      const apiAutocomplete = API_ENDPOINTS.externa.autocomplete(address);

      const response = await fetch(apiAutocomplete, {
        method: "GET",
        headers: {
          "Authentication-Token": jwtToken,
          "Content-Type": "application/json",
        },
      });

      const data = await response.json(); // <- ESTO FALTABA

      let results = [];
      if (Array.isArray(data)) {
        results = data;
      } else if (Array.isArray(data.searchResults)) {
        results = data.searchResults;
      } else {
        console.warn("searchAddresses devolvió algo inesperado:", data);
      }

      cacheRef.current[address] = results;
      return results;
    } catch (error) {
      console.error("Error en searchAddresses:", error);
      return [];
    }
  };

  const validateWithPlaceID = async (placeID) => {
    try {
      const apiAutocompletePlaceID = API_ENDPOINTS.externa.autocompleteplaceid(placeID);
      const response = await fetch(apiAutocompletePlaceID, {
        method: "GET",
        headers: {
          "Authentication-Token": jwtToken,
          "Content-Type": "application/json",
        },
      });

      if (!response.ok) throw new Error(`Error: ${response.statusText}`);

      const data = await response.json();
      if (data?.zone?.id && data?.coordinate?.latitude && data?.coordinate?.longitude) {
        return {
          zoneId: data.zone.id,
          latitude: data.coordinate.latitude,
          longitude: data.coordinate.longitude,
        };
      }

      return null;
    } catch (error) {
      console.error("Error validando con placeID:", error.message);
      return null;
    }
  };

  const processResults = async (address, searchResults, isDestino = false) => {
    if (!Array.isArray(searchResults)) {
      console.warn("searchResults no es un arreglo, convirtiendo a arreglo:", searchResults);
      searchResults = [searchResults];
    }

    const valid = searchResults.find((r) => r.fullAddress?.zone?.id && r.fullAddress?.coordinate?.latitude && r.fullAddress?.coordinate?.longitude);

    if (valid) {
      return {
        address,
        zoneId: valid.fullAddress.zone.id,
        latitude: valid.fullAddress.coordinate.latitude,
        longitude: valid.fullAddress.coordinate.longitude,
        placeID: null,
        isDestino,
      };
    }

    const alternatives = searchResults
      .filter((r) => r.placeID)
      .map((r) => ({
        address: r.address,
        placeID: r.placeID,
      }));

    if (alternatives.length === 1) {
      const validated = await validateWithPlaceID(alternatives[0].placeID);
      if (validated) {
        cacheRef.current[address] = validated;
        return {
          address,
          ...validated,
          placeID: null,
          isDestino,
        };
      }
    }

    return {
      address,
      zoneId: null,
      latitude: null,
      longitude: null,
      alternatives,
      isDestino,
    };
  };

  return {
    normalizeAddress,
    searchAddresses,
    processResults,
    validateWithPlaceID,
  };
};
